import keyMirror from "keymirror";

export default keyMirror({
    ArticleNotResolved: null,
    ArticleResolved: null,
    GetRecommendedArticles: null,
    QuestionSubmitted: null,
    ArticleViewed: null,
    SearchLoaded: null,
});
